<template>
  <div class="preferred-product-price-fields">
    <p v-if="guide" class="preferred-product-price-fields__guide">
      {{ guide }}
    </p>
    <div class="preferred-product-price-fields__list">
      <article
        v-for="product in products"
        :key="product.id"
        class="preferred-product-price-fields__item"
      >
        <img :src="product.imageUrl" :alt="product.name" />
        <div class="preferred-product-price-fields__content">
          <label :for="`preferred-product-price-${product.id}`">
            견적가 *
          </label>
          <el-input
            :id="`preferred-product-price-${product.id}`"
            ref="priceInputs"
            :value="priceForProduct(product.id)"
            inputmode="numeric"
            placeholder="예) 2,000,000"
            @input="handlePriceInput(product.id, $event)"
          >
            <template slot="append">원</template>
          </el-input>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreferredProductPriceFields",
  props: {
    products: { type: Array, default: () => [] },
    priceForProduct: { type: Function, default: () => "" },
    guide: {
      type: String,
      default: "고객이 선택한 각 제품 사진에 맞춰 견적가를 입력해주세요.",
    },
  },
  methods: {
    handlePriceInput(productId, value) {
      this.$emit("price-input", productId, value);
      this.$nextTick(() => {
        const index = this.products.findIndex(
          (product) => product.id === productId
        );
        const inputs = this.$refs.priceInputs;
        const input = Array.isArray(inputs) ? inputs[index] : inputs;
        if (input && typeof input.setNativeInputValue === "function") {
          input.setNativeInputValue();
        }
      });
    },
  },
};
</script>

<style
  src="./PreferredProductPriceFields.styles.scss"
  lang="scss"
  scoped
></style>
